export default __webpack_public_path__ + "static/media/isoftbet.13957213.svg";